import React, { useMemo } from "react";
import { type ToasterProps, useToaster } from "react-hot-toast/headless";
import { twMerge, twJoin } from "tailwind-merge";

import { ToastWrapper } from "./ToastWrapper";
import { ToastBar } from "./ToastBar";

export const Toaster = ({
  reverseOrder,
  position = "top-center",
  toastOptions,
  gutter,
  children,
  containerStyle,
  containerClassName,
  limit,
}: ToasterProps & { limit?: number }) => {
  const { toasts, handlers } = useToaster(toastOptions);

  const allowedToasts = useMemo(() => (limit ? toasts.slice(0, limit) : toasts), [toasts, limit]);

  return (
    <div className={twMerge("fixed z-40 inset-4 pointer-events-none", containerClassName)} style={containerStyle}>
      {allowedToasts.map(t => {
        const toastPosition = t.position ?? position;
        const offset = handlers.calculateOffset(t, {
          reverseOrder,
          gutter,
          defaultPosition: position,
        });

        return (
          <ToastWrapper
            id={t.id}
            key={t.id}
            onHeightUpdate={handlers.updateHeight}
            className={twJoin(
              "sup-toaster flex absolute transition-all duration-200 left-0 right-0",
              t.visible ? "z-40" : "",
              position.includes("top") ? "top-0" : "bottom-0",
              position.includes("center") && "justify-center",
              position.includes("right") && "justify-end"
            )}
            style={{ transform: `translateY(${offset * (position.includes("top") ? 1 : -1)}px)` }}
          >
            <ToastBar toast={t} position={toastPosition} renderToast={children} />
          </ToastWrapper>
        );
      })}
    </div>
  );
};
